import { render } from "./currentService.vue?vue&type=template&id=46895fb9&scoped=true"
import script from "./currentService.vue?vue&type=script&lang=js"
export * from "./currentService.vue?vue&type=script&lang=js"

import "./currentService.vue?vue&type=style&index=0&id=46895fb9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46895fb9"]])

export default __exports__